import { storage } from '../../services/StorageService';
import { bootParam, updateBootSearchParams } from '../../../config/boot/bootUrl';

/**
 * One source of truth for the bottom-right corner freeze tag
 * ("⏱ freeze 166ms · client"), the glance-level sibling of the full
 * center-screen card owned by `freezePopupPreference.ts`.
 *
 * Deliberately NOT symmetric with that module in one respect: it does not
 * consult `isDebugSurface()`. The popup defaults ON for diagnostic surfaces
 * because that is where you want maximum detail. The corner tag is the
 * opposite case — `/debug` and `/combatlab` are exactly where VQA captures are
 * taken, so a surface-based default would stamp the tag into the corner of
 * screenshots taken for entirely unrelated reasons. The stored preference is
 * the authority; `?freezeToast=1` is the session override.
 *
 * Hiding the tag changes nothing about detection: freezes still record durably
 * to the server DomainLog and stay queryable via `dj_h2000_attribute_at`.
 */
export function readFreezeToastEnabled(): boolean {
  if (typeof window !== 'undefined') {
    const override = bootParam('freezeToast');
    if (override === '1') return true;
    if (override === '0') return false;
  }
  return storage.loadUserPrefs().dev.freezeCornerToast;
}

export function writeFreezeToastEnabled(enabled: boolean): void {
  if (typeof window !== 'undefined') {
    // The stored pref carries the choice; a lingering URL flag would silently
    // outrank the next toggle, so clear it whenever the operator picks a value.
    updateBootSearchParams((params) => params.delete('freezeToast'));
  }

  const current = storage.loadUserPrefs();
  storage.saveUserPrefs({
    ...current,
    dev: { ...current.dev, freezeCornerToast: enabled },
  });
}
